import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';

const styles = {
  locationContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  menuContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '4px',
  },
  copyButton: {
    padding: 0,
    height: 24,
    width: 24,
  },
  copyIcon: {
    fontSize: 18,
    color: 'common.grey850',
  },
  menuText: {
    fontSize: 12,
  },
  button: {
    padding: 0,
    height: 24,
  },
  postedOnContainer: {
    padding: 1,
    py: 0.5,
    position: 'absolute',
    // backgroundColor: 'primary.main',
    mt: 1,
    minWidth: 200,
    right: -49,
    bottom: 7,
    borderRadius: '42px',
  },
  postedOnText: { fontSize: 11, color: 'common.grey850', fontWeight: '500' },
  rightSectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    justifyContent: 'space-between',
    flex: 1,
    pb: '8px',
  },
  buttonContainer: {
    width: '100%',
    padding: 0,
    mb: '6px',
  },
  locationIcon: {
    marginRight: '5px',
  },
  menu: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
  },
  footerContainer: {
    backgroundColor: 'secondary.main',
    p: '12px 24px 24px 24px',
    borderTop: '1px solid',
    borderColor: 'common.border',
  },
  zeroMargin: { my: 0 },
  shiftLabel: { mb: '12px' },
  chipContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    alignSelf: 'flex-start',
  },
  strikeContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  strikeText: {
    fontSize: 14,
    textDecoration: 'line-through',
    marginRight: 1,
  },
  topContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'flex-start',
    width: '100%',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
